import React, { useState, useEffect, useRef } from 'react'
import { useForm } from 'react-hook-form'
import { TextField } from '../Base/Form'
import { postData } from '../../../js/helpers/apiHelper'
import Alert from '../Base/Alert'
import { useDispatch } from 'react-redux'
import { setStep } from '../../../js/lib/redux/slices/booking'
import useResponsiveView from '../../hooks/useResponsiveView'
import { Tooltip } from 'bootstrap'
import DOMPurify from 'dompurify'

const ModifySearch = () => {
  const { dictionary, configuration, image } = window.modifySearchData
  const { control, handleSubmit } = useForm()
  const [loading, setLoading] = useState(false)
  const [errorMessages, setErrorMessages] = useState()

  const { isDesktop } = useResponsiveView()
  const dispatch = useDispatch()
  const tooltipRef = useRef(null)

  useEffect(() => {
    if (!isDesktop && tooltipRef.current) {
      const tooltip = new Tooltip(tooltipRef.current, {
        title: DOMPurify.sanitize(dictionary.referenceNumberTooltip),
        html: true,
        trigger: 'hover focus',
      })
      return () => tooltip.dispose()
    }
  }, [isDesktop, dictionary.referenceNumberTooltip])

  const onSubmit = async (data) => {
    try {
      setErrorMessages(null)
      setLoading(true)
      const response = await postData(configuration.endpointModifySearch, data)
      if (!response.hasError) {
        dispatch(setStep(1))
        window.location.href = response.data.redirectUrl
      } else {
        setErrorMessages(response.errorMessages)
      }
    } catch {
      //show general error msg
      setErrorMessages(
        dictionary.defaultErrorMessage
          ? [dictionary.defaultErrorMessage]
          : ['Something went wrong']
      )
    } finally {
      setLoading(false)
    }
  }
  return (
    <div className="s-modify-search">
      <div className="row">
        <div className="col-12 col-md-5">
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="s-modify-search__form">
            {errorMessages && <Alert messages={errorMessages} />}

            <TextField
              name="referenceNumber"
              label={dictionary.referenceNumberLabel}
              placeholder={dictionary.referenceNumberPlaceholder}
              control={control}
              info={isDesktop ? dictionary.referenceNumberTooltip : null}
            />
            {!isDesktop && (
              <div className="s-modify-search__form__tooltip--mobile">
                <span
                  ref={tooltipRef}
                  className="form-text"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  data-bs-title={dictionary.referenceNumberTooltip}>
                  {dictionary.referenceNumberTooltipLabel}
                </span>
              </div>
            )}
            <TextField
              name="surname"
              label={dictionary.surnameLabel}
              placeholder={dictionary.surnamePlaceholder}
              control={control}
            />
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
              title={dictionary.searchBtn}>
              {dictionary.searchBtn}
            </button>
          </form>
        </div>
        <div className="col-md-6 offset-md-1 col-12 offset-0">
          <img
            src={image.src}
            alt={image.alt}
            width={image.width}
            height={image.height}
          />
        </div>
      </div>
    </div>
  )
}

export default ModifySearch
